import styles from './StatCardGrid.module.css';

/**
 * StatCardGrid
 * ────────────
 * Responsive grid wrapper for StatCard components.
 * Defaults to 4 columns, collapses to 2 then 1 on smaller screens.
 *
 * @param {ReactNode} children   <StatCard /> elements
 * @param {number}    [cols=4]   Max columns
 *
 * Usage:
 *   <StatCardGrid>
 *     <StatCard ... />
 *     <StatCard ... />
 *   </StatCardGrid>
 */
export default function StatCardGrid({ children, cols = 4 }) {
  return (
    <div className={styles.grid} style={{ '--cols': cols }}>
      {children}
    </div>
  );
}
